module.exports = __webpack_public_path__ + "img/31-Frequent hair loss.1c717582.png";